import { Card, Tab, TabContext, Typography } from "@compass/core";
import { LkPersonType } from "generated/openApi";
import Tabs from "@mui/material/Tabs";

export const PersonTypeTabs = (props: {
  personTypes: LkPersonType[];
  value: number;
  onChange: (value: number) => void;
}) => {
  // const currentTab = 1;

  return (
    <Card sx={{ height: "100%" }} bodySx={{ p: 0 }}>
      {/* <Typography textAlign={"center"} variant="h6">
        Conversation Type
      </Typography> */}
      <Tabs
        orientation="horizontal"
        onChange={(e, value) => {
          props.onChange(value);
          // navigate(`../${textingConversationListPageRoute.getPath({ id: id, crudMode: crudMode })}`);
        }}
        value={props.value}
        variant="standard"
        scrollButtons
        allowScrollButtonsMobile
      >
        {props.personTypes.map((personType) => (
          <Tab key={personType.id} label={personType.name} value={personType.id} />
        ))}
      </Tabs>
    </Card>
  );
};
